"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const SimpleTag_1 = __importDefault(require("../../../atoms/tag/SimpleTag"));
const ListTag = ({ labels = [], onClick = () => ({}), style = {}, }) => {
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { component: "div", sx: { p: 1 }, style: style, children: labels.map(l => ((0, jsx_runtime_1.jsx)(SimpleTag_1.default, { id: l.key || '', label: l.label || '', onClick: l.disabledRemove ? null : () => onClick(l.key) }, l.label))) }));
};
exports.default = ListTag;
